import React, { Component } from "react";
import { Select } from "antd";

class SelectOrg extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  componentWillReceiveProps() {}

  render() {
    return (
      <Select
        onChange={this.props.onChange}
        style={{ width: "100%" }}
        placeholder="资料库选择"
        value={this.props.value}
      >
        {this.props.data.map(item => {
          return (
            <Select.Option value={item.uuid} key={item.uuid}>
              {item.name}
            </Select.Option>
          );
        })}
      </Select>
    );
  }
}

export default SelectOrg;



// WEBPACK FOOTER //
// ./src/components/administrative/material/SelectDatabase.js